import { render, staticRenderFns } from "./FileViewerImage.vue?vue&type=template&id=79b55d60&scoped=true&"
import script from "./FileViewerImage.vue?vue&type=script&lang=ts&"
export * from "./FileViewerImage.vue?vue&type=script&lang=ts&"
import style0 from "./FileViewerImage.vue?vue&type=style&index=0&id=79b55d60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b55d60",
  null
  
)

export default component.exports